import React, { useState } from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

import { FaLinkedinIn, FaFacebookF } from "react-icons/fa"
import "./navbar.scss"

export const NavBar = ({ darkBackground, classTitle }) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggle = () => setIsOpen(!isOpen)

  return (
    <section className="header">
      <Navbar className={`p-0 ${classTitle}-navbar`} expand="xl">
        <div className="logo-container">
          {!darkBackground ? (
            <Link className="navbar-brand text-dark p-0 m-0" to="/">
              <StaticImage
                src="../../images/home/Skol-imagotipo-web-escritotio.svg"
                alt="logo"
                className="logo"
                placeholder="tracedSVG"
              />
            </Link>
          ) : (
            <Link className="navbar-brand text-dark p-0 m-0" to="/">
              <StaticImage
                src="../../images/home/Skol-imagotipo-web-escritotio_Logo Blanco.svg"
                alt="logo"
                className="logo"
                placeholder="tracedSVG"
              />
            </Link>
          )}
        </div>
        <NavbarToggler onClick={toggle} />

        <Collapse isOpen={isOpen} navbar>
          <Nav className="text-center" navbar>
            <NavItem>
              <Link
                to="/quienes-somos"
                className={`${classTitle}-nav-link nav-link`}
              >
                Quienes somos
              </Link>
            </NavItem>

            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav className={`${classTitle}-nav-link`}>
                Soluciones
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem>
                  <Link
                    to="/soluciones/salas-multimedia"
                    className={`${classTitle}-dropdown-nav-link nav-link`}
                  >
                    Salas Multimedia
                  </Link>
                </DropdownItem>
                <DropdownItem>
                  <Link
                    to="/soluciones/videoconferencia"
                    className={`${classTitle}-dropdown-nav-link nav-link`}
                  >
                    Videoconferencia
                  </Link>
                </DropdownItem>
                <DropdownItem>
                  <Link
                    to="/soluciones/automatizacion"
                    className={`${classTitle}-dropdown-nav-link nav-link`}
                  >
                    Automatización
                  </Link>
                </DropdownItem>
                <DropdownItem>
                  <Link
                    to="/soluciones/videowall"
                    className={`${classTitle}-dropdown-nav-link nav-link`}
                  >
                    Videowall / Display
                  </Link>
                </DropdownItem>
                <DropdownItem>
                  <Link
                    to="/soluciones/sonorizacion"
                    className={`${classTitle}-dropdown-nav-link nav-link`}
                  >
                    Sonorización
                  </Link>
                </DropdownItem>
                <DropdownItem>
                  <Link
                    to="/soluciones/mobiliario"
                    className={`${classTitle}-dropdown-nav-link nav-link`}
                  >
                    Mobiliario
                  </Link>
                </DropdownItem>
                <DropdownItem>
                  <Link
                    to="/soluciones/proyectores"
                    className={`${classTitle}-dropdown-nav-link nav-link`}
                  >
                    Proyectores
                  </Link>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>

            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav className={`${classTitle}-nav-link`}>
                Soporte
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem>
                  <Link
                    to="/soporte/servicios"
                    className={`${classTitle}-dropdown-nav-link nav-link`}
                  >
                    Servicios
                  </Link>
                </DropdownItem>
                <DropdownItem>
                  <Link
                    to="/soporte/planes"
                    className={`${classTitle}-dropdown-nav-link nav-link`}
                  >
                    Planes
                  </Link>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>

            <NavItem>
              <Link
                to="/clientes"
                className={`${classTitle}-nav-link nav-link`}
              >
                Clientes
              </Link>
            </NavItem>
            <NavItem>
              <Link
                to="/contacto"
                className={`${classTitle}-nav-link nav-link`}
              >
                Contacto
              </Link>
            </NavItem>
            <NavItem>
              <a
                href="https://www.linkedin.com/company/skol-solutions/"
                className={`${classTitle}-nav-link nav-link linkedin`}
              >
                <FaLinkedinIn />
              </a>
            </NavItem>
            <NavItem>
              <a
                href="https://www.facebook.com/"
                className={`${classTitle}-nav-link nav-link facebook`}
              >
                <FaFacebookF />
              </a>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </section>
  )
}
